import React, { useState } from 'react';
import Wrapper from './components/Wrapper';
import { makeStyles } from '@material-ui/core/styles';
import TopBar from './components/TopBar';
import SideMenu from './components/SideMenu/SideMenuContainer';

const useStyle = makeStyles({
  root: {
    backgroundColor: '#51983A',
    minHeight: '100vh',
    width: '100%',
    overflowY: 'auto',
  },
});
export default function App() {
  const classes = useStyle();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState();
  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };
  return (
    <div
      className={classes.root}
      style={{
        backgroundColor: `${backgroundImage}`,
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <TopBar toggleDrawer={toggleDrawer} />
      <Wrapper />
      <SideMenu
        open={openDrawer}
        toggleDrawer={toggleDrawer}
        setBackgroundImage={setBackgroundImage}
      />
    </div>
  );
}
